// @flow
import React from 'react';
import styled from 'styled-components';

const StyledPagination = styled.div`
    height: 72px;
    overflow: hidden;
    text-align: center;
    background: #edf1f2;
    border-top: 1px solid #d9d9db;

    ul {
        background-color: #ffffff;
        box-shadow: 0 1px 1px 0 rgba(85, 95, 110, 0.2);
        border: solid 1px #d4d8e3;
        width: auto;
        display: inline-block;
        border-radius: 4px;
        padding: 8px 16px;
        height: 26px;
    }

    li {
        display: block;
        padding: 3px;
        width: 28px;
        height: 18px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        float: left;

        &[disabled],
        &:disabled,
        &.itemDisabled {
            visibility: visible;
            color: #bbbbbb;
            opacity: 0.5;
            pointer-events: none;
            line-height: 16px;
        }

        &.itemSelected {
            color: #fff;
            background: #e76424;

            button {
                color: currentColor;
                font-weight: normal;
                text-decoration: none;
            }
        }

        &:hover,
        &:focus {
            background: rgba(39, 81, 175, 0.1);

            .itemLink {
                color: #e76424;
            }
        }
    }

    .itemLink {
        text-decoration: none;
        color: #697782;
        display: block;
        width: 100%;
        height: 18px;
    }

    button {
        border: 0;
        background: transparent;
        cursor: pointer;
    }
`;

const Pagination = (props: any) => {
    const { onPageChange, pagination } = props;

    const { previousPage, nextPage } = pagination;

    const currentPage = pagination.page;

    const segments = pagination.segments;
    let previousPages = null;
    let nextPages = null;

    if (segments) {
        previousPages = segments.previousPages.length ? true : false;
        nextPages = segments.nextPages.length ? true : false;
    }

    const pageCount = pagination.pageCount > 0 ? true : false;

    return (
        <StyledPagination>
            <ul>
                {pageCount &&
                    previousPages &&
                    <li className="itemFirst">
                        <button
                            className="itemLink"
                            aria-label="Page 1"
                            onClick={e => {
                                onPageChange(1);
                            }}
                        >
                            «
                        </button>
                    </li>}
                {(!pageCount || !previousPages) &&
                    <li className="itemDisabled itemFirst" disabled>
                        <span className="itemLink">«</span>
                    </li>}
                {pageCount &&
                    previousPages &&
                    <li className="itemPrevious">
                        <button
                            className="itemLink"
                            aria-label={`Page ${previousPage}`}
                            onClick={e => {
                                onPageChange(previousPage);
                            }}
                        >
                            ‹
                        </button>
                    </li>}
                {(!pageCount || !previousPages) &&
                    <li className="itemDisabled itemPrevious" disabled>
                        <span className="itemLink">‹</span>
                    </li>}
                {pageCount &&
                    previousPages &&
                    pagination.segments.previousPages.map(page => {
                        return (
                            <li key={page} className="itemPage">
                                <button
                                    className="itemLink"
                                    aria-label={`Page ${page}`}
                                    onClick={e => {
                                        onPageChange(page);
                                    }}
                                >
                                    {page}
                                </button>
                            </li>
                        );
                    })}
                {pageCount &&
                    currentPage &&
                    <li key={currentPage} className="itemSelected itemPage">
                        <button
                            className="itemLink"
                            aria-label={`Page ${currentPage}`}
                            onClick={e => {
                                onPageChange(currentPage);
                            }}
                        >
                            {currentPage}
                        </button>
                    </li>}
                {pageCount &&
                    nextPages &&
                    pagination.segments.nextPages.map(page => {
                        return (
                            <li key={page} className="itemPage">
                                <button
                                    className="itemLink"
                                    aria-label={`Page ${page}`}
                                    onClick={e => {
                                        onPageChange(page);
                                    }}
                                >
                                    {page}
                                </button>
                            </li>
                        );
                    })}
                {pageCount &&
                    nextPages &&
                    <li className="itemNext">
                        <button
                            className="itemLink"
                            aria-label={`Page ${nextPage}`}
                            onClick={e => {
                                onPageChange(nextPage);
                            }}
                        >
                            ›
                        </button>
                    </li>}
                {(!pageCount || !nextPages) &&
                    <li className="itemDisabled itemNext" disabled>
                        <span className="itemLink">›</span>
                    </li>}
            </ul>
        </StyledPagination>
    );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/shared/Pagination.js